import { Card, Input, CardBody, Button, CardFooter, useSelect } from "@nextui-org/react"
import { useState } from "react"
import { ErrorCard, MainContainer } from "../components"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"
import { usePost } from "../api/reactQueryCustomHooks"
import { apiRoute } from "../constants/enum"

const ResetPassword = () => {
    const { user } = useSelector((state) => state.auth)
    const [isVisible, setIsVisible] = useState(false)
    const toggleVisibility = () => setIsVisible(!isVisible)

    let [msg, setMsg] = useState("")
    let [msgPwd, setMsgPWD] = useState("")
    let [formData, setFormData] = useState({
        email: "",
        password: "",
        confirmPassword: ""
    })
    const handleChange = (e) => {
        const { value, name } = e.target;
        setFormData({ ...formData, [name]: value })
        if (name == "email") {
            if (value == user.userEmail) {
                setMsg("");
            }
            else {
                setMsg("Email Not Match With Registered Email")
            }
        }
        if (name == "password") {
            if (value.length<8) {
                setMsgPWD("Password must have atleast 8 character")
            }
            else {
                setMsgPWD("")
            }
        }
    }
    const onSuccessTasks = (data) => {
        toast.success("Password Reset successfully", {
            position: "top-center"
        })
    }
    const resetValues = () => {
        setFormData({})
        setMsg("")
        setMsgPWD("")
    }
    const { isPending, isError, mutate: funResetPwd } = usePost({
        url: apiRoute.resetPassword,
        queryKey: "resetPassword",
        onSuccessTasks,
        resetValues

    })
    if (isError) {
        return <ErrorCard />
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        if (formData.confirmPassword.trim() !== formData.password.trim()) {
            toast.error("Confirm Password should be same as Password", {
                position: "top-center"
            })
        }
        if (msg) {
            toast.error(msg, {
                position: "top-center"
            })
        }
        if (msgPwd) {
            toast.error(msgPwd, {
                position: "top-center"
            })
        }
        if (msgPwd==""&&msg == "" && formData.confirmPassword.trim() == formData.password.trim()) {
            funResetPwd({
                data: {
                    user_id: user.userid,
                    new_password: formData.password
                }
            })
        }
    }
    return (
        <div>
            <MainContainer  pageName="Reset Password" breadcrumbs={["User", "Reset Password"]}>
               
                {/* <h2 className="mb-4 text-center font-bold leading-none tracking-tight
                 text-gray-900 md:text-1xl lg:text-xl dark:text-white" >Reset Password</h2> */}
                <div className=" shadow pb-5 flex flex-col item-center min-w-md">


                    <form onSubmit={handleSubmit}>


                        <div className="items-center gap-2 p-5">
                            <Input
                                type="email"
                                label="Email ID"
                                placeholder=" "
                                size="md"
                                labelPlacement="outside"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                isRequired

                            />
                            <div className="alert alert-danger text-sm text-red-800">
                                {msg}
                            </div>
                        </div>
                        <div className="items-center gap-2 px-5">
                            <Input
                                isRequired
                                label="New Pasword"
                                placeholder=" "
                                size="md"
                                labelPlacement="outside"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                endContent={
                                    <button
                                        className="focus:outline-none"
                                        type="button"
                                        onClick={toggleVisibility}
                                    >
                                        {isVisible ? (
                                            <FontAwesomeIcon icon={faEyeSlash} />
                                        ) : (
                                            <FontAwesomeIcon icon={faEye} />
                                        )}
                                    </button>
                                }
                                type={isVisible ? "text" : "password"}

                            />
                            <div className="alert alert-danger text-sm text-red-800">
                                {msgPwd}
                            </div>
                        </div>
                        <div className="items-center gap-2 p-5">
                            <Input
                                isRequired
                                label="Confirm Pasword"
                                placeholder=" "
                                size="md"
                                labelPlacement="outside"
                                name="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                                endContent={
                                    <button
                                        className="focus:outline-none"
                                        type="button"
                                        onClick={toggleVisibility}
                                    >
                                        {isVisible ? (
                                            <FontAwesomeIcon icon={faEyeSlash} />
                                        ) : (
                                            <FontAwesomeIcon icon={faEye} />
                                        )}
                                    </button>
                                }
                                type={isVisible ? "text" : "password"}

                            />
                        </div>


                        <div className="flex justify-center">
                            <Button color="primary" type="submit" size="md" isLoading={isPending} >
                                Reset Password
                            </Button>
                        </div>


                    </form>


                </div>
            </MainContainer>
        </div>
    )
}
export default ResetPassword